var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalandcompanydetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 14,
    xmlSpace: "preserve",
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 14,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAASNJREFUOE+tklFZQzEUgxMHSGAOwAHXARLAwVAAU8BQwBwACpgDcMB1sDkI/P1avrvujif61LSnaZJzrG4luZe0lHQm6VPSyvZrkvd6VvD0macgyWMl6LkHSc+SzuvFYHvbin5JklDwNS1K8iAJZVvbQ4/nSK4lvUh6s81eSbC0Y2/bPZ4juZKE772khe19kkY82l4kaTUFH5HUnz8kXUgaa6g8Qs2qkmOtYNtYLasPllxQ0wKk5ulH1TIJtiAo+GR32kWVDRGBoop8CnHDRyT1EVKRP7fIidnAFgu1tBhbI4m38E68PzhG1V3tIhfgS0hamPyypis9W7VC+wmduk0lKhiStDn4S0qSmzq1G9u3B/i/SMqoT4dnTlESpGOJFq+n+BuP754+Pj5Z6AAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalandcompanydetailsIcon);
export default __webpack_public_path__ + "static/media/personalandcompanydetails-icon.69519af892607ac2c01f0e462cb37ba6.svg";
export { ForwardRef as ReactComponent };